<template>
  <card-kiosk>
    <div class="text-center card-error-checkin mx-auto">
      <div class="padding-40 h-100 d-flex align-items-start flex-column">
        <img src="@/assets/img/error.png" width="64" class="mx-auto" v-if="dataConfig.ticketNo"/>
        <template v-if="!dataConfig.page">
          <p class="c-deep fs-38 fw-600 mx-auto line-46 mt-1 margin-bottom-36">QR Code tidak dapat digunakan</p>
          <div class="row mb-4 text-left">
            <div class="col-md-12">
              <p class="c-warning-A fs-22 fw-600 margin-bottom-21 line-27">
                Hal ini mungkin terjadi karena:
              </p>
              <ul class="c-warning-A line-27 mb-0">
                <li class=" fw-500 fs-22 text-justify">
                  Nomor tiket Anda belum didaftarkan pada jadwal yang tersedia
                </li>
                <li class=" fw-500 fs-22 text-justify">
                  Nomor tiket sudah tidak berlaku
                </li>
                <li class=" fw-500 fs-22 text-justify">
                 Sesi konsultasi Anda sudah selesai
                </li>
                <li class=" fw-500 fs-22 text-justify">
                  Jam praktik sudah selesai
                </li>
              </ul>
            </div>
          </div>
          <div class="mt-auto">
            <div class="grid-template-information margin-bottom-26">
                 <img
                  src="@/assets/icon/information.svg"
                  class="mt-1"
                  width="20"
                  alt=""
                />
                <div class="c-primary fw-600 fs-18 text-justify ">
                Jika ada kendala dengan kode booking/QR Code Anda, silakan menuju
                Pendaftaran atau menghubungi staff kami
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-md-1">
                <img
                  src="@/assets/icon/information.svg"
                  class="mt-3"
                  width="20"
                  alt=""
                />
              </div>
              <div class="col-md-11 c-primary fw-600 fs-18 text-justify margin-bottom-26">
                Jika ada kendala dengan kode booking/QR Code Anda, silakan menuju
                Pendaftaran atau menghubungi staff kami
              </div>
            </div> -->
            <button-time-out class="fs-18" :time="dataConfig.timeOutCancel" @click="goToRoute()" />
          </div>
        </template>
        <template v-else-if="dataConfig.page == 'NO ORDER'">
          <p class="c-deep fs-38 fw-600 mx-auto line-46 mt-1 mb-18">Tiket belum didaftarkan!</p>
          <div class="mx-auto padding-error-ticket error-show-container font-inconsolata mb-18">
            <p class="fw-600 fs-24">Nomor Tiket:</p>
            <p class="fw-700 fs-82 line-height-1">{{ dataConfig.ticketNo }}</p>

          </div>
          <div class="mt-auto mx-auto">
            <div class="grid-template-information margin-bottom-26">
                 <img
                  src="@/assets/icon/information.svg"
                  class="mt-1"
                  width="20"
                  alt=""
                />
                <div class="c-warning-A fw-600 fs-18 text-justify ">
                Harap menuju bagian <span class="fw-700">Pendaftaran</span> atau hubungi staf kami untuk proses lebih lanjut.
              </div>
            </div>
            <button-time-out class="fs-18" :time="dataConfig.timeOutCancel" @click="goToRoute()" />
          </div>
        </template>
        <template v-else-if="dataConfig.page == 'NO ROOM'">
          <p class="c-deep fs-38 fw-600 mx-auto line-46 mt-1 mb-18">Ruangan belum diatur</p>
          <div class="mx-auto padding-error-ticket error-show-container font-inconsolata mb-18">
            <p class="fw-600 fs-24">Nomor Tiket:</p>
            <p class="fw-700 fs-82 line-height-1">{{ dataConfig.ticketNo }}</p>

          </div>
          <div class="mt-auto mx-auto">
            <div class="grid-template-information margin-bottom-26">
                 <img
                  src="@/assets/icon/information.svg"
                  class="mt-1"
                  width="20"
                  alt=""
                />
                <div class="c-warning-A fw-600 fs-18 text-justify ">
                Data ruangan dokter belum diatur, silakan hubungi perawat kami.
              </div>
            </div>
            <button-time-out class="fs-18" :time="dataConfig.timeOutCancel" @click="goToRoute()" />
          </div>
        </template>
        <template v-else-if="dataConfig.page == 'REMOVE TICKET'">
          <p class="c-deep fs-38 fw-600 mx-auto line-46 mt-1 mb-18">Tiket sudah dihapus!</p>
          <div class="mx-auto padding-error-ticket error-show-container font-inconsolata mb-18">
            <p class="fw-600 fs-24">Nomor Tiket:</p>
            <p class="fw-700 fs-82 line-height-1">{{ dataConfig.ticketNo }}</p>

          </div>
          <div class="mt-auto mx-auto">
            <div class="grid-template-information margin-bottom-26">
                 <img
                  src="@/assets/icon/information.svg"
                  class="mt-1"
                  width="20"
                  alt=""
                />
                <div class="c-warning-A fw-600 fs-18 text-justify ">
                Silakan hubungi staf kami untuk proses lebih lanjut.
              </div>
            </div>
            <button-time-out class="fs-18" :time="dataConfig.timeOutCancel" @click="goToRoute()" />
          </div>
        </template>
        <template v-else-if="dataConfig.page == 'EXPIRED TICKET'">
          <div class="mt-auto mx-auto">
            <img src="@/assets/img/error.png" width="64" class="mx-auto" />
            <p class="c-deep fs-38 fw-600 mx-auto line-46 mt-1 mb-18">Tiket sudah tidak berlaku!</p>
          </div>
          <div class="mt-auto mx-auto">
            <div class="grid-template-information margin-bottom-26">
                 <img
                  src="@/assets/icon/information.svg"
                  class="mt-1"
                  width="20"
                  alt=""
                />
                <div class="c-warning-A fw-600 fs-18 text-center ">
                Silakan hubungi staf kami untuk proses lebih lanjut.
              </div>
            </div>
            <button-time-out class="fs-18" :time="dataConfig.timeOutCancel" @click="goToRoute()" />
          </div>
        </template>
        <template v-else-if="dataConfig.page == 'TICKET_APPOINTMENT'">
          <div class="mt-auto mx-auto">
            <img src="@/assets/img/error.png" width="64" class="mx-auto" />
            <p class="c-deep fs-38 fw-600 mx-auto line-46 mt-1 mb-18">Kode QR tidak dapat digunakan</p>
          </div>
          <div class="mt-auto mx-auto">
            <div class="grid-template-information margin-bottom-26">
                 <img
                  src="@/assets/icon/information.svg"
                  class="mt-1"
                  width="20"
                  alt=""
                />
                <div class="c-warning-A fw-600 fs-18 text-center ">
                Silakan menuju <strong>Pendaftaran</strong> untuk mencetak tiket antrian dan melakukan daftar ulang.
              </div>
            </div>
            <button-time-out class="fs-18" :time="dataConfig.timeOutCancel" @click="goToRoute()" />
          </div>
        </template>
        <template v-else-if="dataConfig.page == 'TIMEOUT'">
          <div class="mt-auto mx-auto" v-if="!dataConfig.ticketNo">
            <img src="@/assets/img/error.png" width="64" class="mx-auto" />
            <p class="c-deep fs-38 fw-600 mx-auto line-46 mt-1 mb-18">Koneksi timeout. Mohon scan tiket kembali.</p>
          </div>
          <template v-else>
            <p class="c-deep fs-38 fw-600 mx-auto line-46 mt-1 mb-18">Koneksi timeout. Mohon scan tiket kembali.</p>
            <div class="mx-auto padding-error-ticket error-show-container font-inconsolata mb-18">
              <p class="fw-600 fs-24">Nomor Tiket:</p>
              <p class="fw-700 fs-82 line-height-1">{{ dataConfig.ticketNo }}</p>
            </div>
          </template>
          <div class="mt-auto mx-auto">
            <div class="grid-template-information margin-bottom-26">
                 <img
                  src="@/assets/icon/information.svg"
                  class="mt-1"
                  width="20"
                  alt=""
                />
                <div class="c-warning-A fw-600 fs-18 text-center ">
                Terdapat kendala koneksi ke server
              </div>
            </div>
            <button-time-out class="fs-18" :time="dataConfig.timeOutCancel" @click="goToRoute()" />
          </div>
        </template>
        <template v-else-if="dataConfig.page == 'ERROR SERVER'">
          <div class="mt-auto mx-auto" v-if="!dataConfig.ticketNo">
            <img src="@/assets/img/error.png" width="64" class="mx-auto" />
            <p class="c-deep fs-38 fw-600 mx-auto line-46 mt-1 mb-18">Kendala server. Mohon scan tiket kembali.</p>
          </div>
           <template v-else>
            <p class="c-deep fs-38 fw-600 mx-auto line-46 mt-1 mb-18">Kendala server. Mohon scan tiket kembali.</p>
            <div class="mx-auto padding-error-ticket error-show-container font-inconsolata mb-18">
              <p class="fw-600 fs-24">Nomor Tiket:</p>
              <p class="fw-700 fs-82 line-height-1">{{ dataConfig.ticketNo }}</p>
            </div>
          </template>
          <div class="mt-auto mx-auto">
            <div class="grid-template-information margin-bottom-26">
                 <img
                  src="@/assets/icon/information.svg"
                  class="mt-1"
                  width="20"
                  alt=""
                />
                <div class="c-warning-A fw-600 fs-18 text-center ">
                Terdapat kendala koneksi ke server
              </div>
            </div>
            <button-time-out class="fs-18" :time="dataConfig.timeOutCancel" @click="goToRoute()" />
          </div>
        </template>
      </div>
    </div>
  </card-kiosk>
</template>
<script>
import CardKiosk from '@/components/kioskCheckIn/Card.vue'
import ButtonTimeOut from '@/components/Button/ButtonTimeOut.vue'
import { useSelector } from '@xstate/vue'
export default {
  data () {
    const infoDetailConfig = (state) => {
      return {
        timeOutCancel: state.context.config && state.context.config.delay && state.context.config.delay.timeOutCancel ? state.context.config.delay.timeOutCancel : 5,
        page: state.context.errorPageType && state.context.errorPageType.page ? state.context.errorPageType.page : null,
        ticketNo: state.context.errorPageType && state.context.errorPageType.ticketNo ? state.context.errorPageType.ticketNo : null
      }
    }
    const infoConfig = useSelector(window.fetchKioskCheckIn, infoDetailConfig)
    return {
      dataConfig: infoConfig
    }
  },
  components: {
    CardKiosk,
    ButtonTimeOut
  },
  methods: {
    goToRoute () {
      window.fetchKioskCheckIn.send({
        type: 'backToIdle'
      })
    }
  }
}
</script>
